import { ConnectError } from "@connectrpc/connect";
import { GetCreditCardsResponse } from "schema/gen/es/chiikipoint/wallet/v2/service_pb";
import type { WalletClient } from "../../libs/client";
import {
  getGMOPGErrorInfo,
  isGMOPGMemberNotFoundError,
} from "../../libs/connect";
import { showGMOPGErrorToast } from "./gmopg-error-toast";

type GetCreditCardsOrEmptyResult = {
  response: GetCreditCardsResponse;
  recoveredFromGMOPGError: boolean;
};

export async function getCreditCardsOrEmpty(
  client: WalletClient,
): Promise<GetCreditCardsOrEmptyResult> {
  try {
    return {
      response: await client.getCreditCards({}),
      recoveredFromGMOPGError: false,
    };
  } catch (error) {
    if (error instanceof ConnectError && isGMOPGMemberNotFoundError(error)) {
      return {
        response: new GetCreditCardsResponse({ cards: {} }),
        recoveredFromGMOPGError: false,
      };
    }

    if (error instanceof ConnectError) {
      const gmoError = getGMOPGErrorInfo(error);
      if (gmoError) {
        showGMOPGErrorToast(gmoError);
        return {
          response: new GetCreditCardsResponse({ cards: {} }),
          recoveredFromGMOPGError: true,
        };
      }
    }

    throw error;
  }
}
